import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { wsGetAll } from 'services/WService';

export const LayerContext = createContext({
  // Divisiones
  divitions: [],
  selectedDivition: undefined,
  setSelectedDivition: () => {},
  excludedDivitions: [],
  setExcludedDivitions: () => {},
  filteredDivitions: [],
  // Capas
  layers: [],
  selectedLayer: undefined,
  setSelectedLayer: () => {},
  filteredLayers: [],
});

export const LayerProvider = ({ children, defaultLayerName }) => {
  const [divitions, setDivitions] = useState([]);
  const [excludedDivitions, setExcludedDivitions] = useState([]);
  const [selectedDivition, setSelectedDivition] = useState();
  const [layers, setLayers] = useState([]);
  const [selectedLayer, setSelectedLayer] = useState();

  async function getData() {
    let [divitionRes, layerRes] = await Promise.all([
      wsGetAll('base/layer-divition'),
      wsGetAll('base/layer'),
    ]);
    if (divitionRes.success) {
      setDivitions(divitionRes.data);
      if (divitionRes.data.length > 0) {
        setSelectedDivition(divitionRes.data[0]);
      }
    }

    if (layerRes.success) {
      setLayers(layerRes.data);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (layers.length === 0 || !selectedDivition) return;
    let deLaDivition = layers.filter((layer) => layer.divition.id === selectedDivition.id);
    // si la capa elegida ya es de esta división se respeta: el mapa de rutas pone la de la ruta
    // junto con su división, y sin esto se pisaba con la primera de la división
    if (selectedLayer && deLaDivition.some((layer) => layer.id === selectedLayer.id)) return;
    let preferida = defaultLayerName
      ? deLaDivition.find((layer) => layer.name === defaultLayerName)
      : undefined;
    setSelectedLayer(preferida || deLaDivition[0]);
  }, [layers, selectedDivition, defaultLayerName]);

  const filteredLayers = useMemo(() => {
    if (layers.length === 0) return [];
    if (selectedDivition === undefined) return [];
    return layers.filter((layer) => layer.divition.id === selectedDivition.id);
  }, [layers, selectedDivition]);

  const filteredDivitions = useMemo(() => {
    if (divitions.length === 0) return [];
    return divitions.filter((divition) => !excludedDivitions.includes(divition.id));
  });

  return (
    <LayerContext.Provider
      value={{
        // Divisiones
        divitions,
        selectedDivition,
        setSelectedDivition,
        excludedDivitions,
        setExcludedDivitions,
        filteredDivitions,
        // Capas
        layers,
        selectedLayer,
        setSelectedLayer,
        filteredLayers,
      }}
    >
      {children}
    </LayerContext.Provider>
  );
};

const useLayerContext = () => useContext(LayerContext);
export default useLayerContext;
